import { Action } from 'redux';
import { connect } from 'react-redux';
import { dispatchAsync } from 'react-redux-dispatch-async';
import { AdminDevToolsDumb } from './AdminDevTools.dumb';
import { AppState } from '../../../common/configuration/app.states';
import { loadUsersRequest, sendSignUpRequest } from '../../usecases/Auth.actions';
import { getConnectedUser } from '../../usecases/Auth.selectors';
import { User } from '../../domain/entities/User';

const mapState = (state: AppState) => ({
  connectedUser: getConnectedUser(state),
});

const mapDispatch = (dispatch: (a: Action) => void) => ({
  loadUsersAsync: () => dispatchAsync(dispatch, loadUsersRequest()),
  sendSignUpAsync: (newUser: User) => dispatchAsync(dispatch, sendSignUpRequest(newUser)),
});

export const AdminDevToolsSmart = connect(mapState, mapDispatch)(AdminDevToolsDumb);
